(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ice-award-wage"] && !Shopify.designMode) return;
  try {
    function iceAwardEstimate(v) {
  const permanent=[[2574,3218,3861,5792],[2644,3305,3966,5949],[2708,3385,4062,6093],[2797,3496,4196,6293],[2945,3681,4418,6626],[3130,3913,4695,7043],[3213,4016,4820,7229]];
  const casual=[[3218,3861,4505,6435],[3305,3966,4627,6610],[3385,4062,4739,6770],[3496,4196,4895,6993],[3681,4418,5154,7363],[3913,4695,5478,7825],[4016,4820,5623,8033]];
  const d=['weekday','saturday','sunday','holiday'].indexOf(v.day), l=Number(v.level), c=v.employment==='casual';
  if(!['hospitality','restaurant'].includes(v.award)||!['casual','part','full'].includes(v.employment)||!Number.isInteger(l)||l<0||l>6||v.level===''||d<0||!v.scope) return {error:'invalid'};
  if([v.ordinary,v.overtime,v.late,v.early].some(x=>typeof x!=='number'||!Number.isFinite(x)||x<0)||v.ordinary+v.overtime>24) return {error:'invalid'};
  const min=c?2:d===3?4:v.employment==='part'?3:6;
  if(v.ordinary<min||v.ordinary>(c?12:11.5)) return {error:'minimum'};
  if(v.late+v.early>v.ordinary||v.late>(v.award==='restaurant'?2:5)||v.early>(v.award==='restaurant'?6:7)||(d!==0&&(v.late||v.early))) return {error:'late_invalid'};
  const base=permanent[l][0];
  let ordinaryRate=(c?casual:permanent)[l][d];
  if(c&&v.award==='restaurant'&&d===2&&l<3) ordinaryRate=casual[l][1];
  let firstRate=d===0?permanent[l][2]:d===1&&v.award==='restaurant'?casual[l][2]:base*2;
  let afterRate=base*2;
  if(d===3) firstRate=afterRate=(c?casual:permanent)[l][3];
  const firstHours=Math.min(2,v.overtime), afterHours=Math.max(0,v.overtime-2);
  const ordinaryPay=Math.round(v.ordinary*ordinaryRate), firstPay=Math.round(firstHours*firstRate), afterPay=Math.round(afterHours*afterRate), addition=Math.ceil(v.late)*295+Math.ceil(v.early)*442;
  return {base,ordinaryRate,ordinaryPay,firstHours,firstRate,firstPay,afterHours,afterRate,afterPay,addition,total:ordinaryPay+firstPay+afterPay+addition};
}
(() => {
  function mount() {
    document.querySelectorAll('[data-ice-wage]').forEach(root=>{
      if(root.dataset.ready) return; root.dataset.ready='true';
      const form=root.querySelector('form'), messages=JSON.parse(root.querySelector('[data-wage-messages]').textContent), error=root.querySelector('[data-wage-error]'), result=root.querySelector('[data-wage-result]'), empty=root.querySelector('[data-wage-empty]');
      const money=c=>new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'}).format(c/100);
      let active=false;
      function calculate(show) {
        const v={}; ['award','employment','level','day'].forEach(k=>v[k]=form.elements[k].value);
        ['ordinary','overtime','early','late'].forEach(k=>v[k]=form.elements[k].value.trim()===''?NaN:Number(form.elements[k].value));
        v.scope=form.elements.scope.checked;
        root.querySelector('[data-wage-late-help]').textContent=messages[v.award==='restaurant'?'restaurant_late':'hospitality_late'];
        form.elements.late.max=v.award==='restaurant'?2:5;form.elements.early.max=v.award==='restaurant'?6:7;
        const r=new Date().getFullYear()>=2027&&new Date()>=new Date(2027,6,1)?{error:'expired'}:iceAwardEstimate(v);
        error.hidden=true;
        if(r.error){result.hidden=true;empty.hidden=false;if(show){error.textContent=messages[r.error];error.hidden=false;}return;}
        if(!active)return;
        result.hidden=false;empty.hidden=true;root.querySelector('[data-wage-total]').textContent=money(r.total);
        root.querySelector('[data-wage-selection]').textContent=['award','employment','level','day'].map(k=>form.elements[k].selectedOptions[0].textContent).join(' · ');
        const dl=root.querySelector('[data-wage-breakdown]');dl.replaceChildren();
        function row(label,value){const wrap=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;wrap.append(dt,dd);dl.append(wrap);}
        row(messages.base,money(r.base));row(messages.ordinary_rate,money(r.ordinaryRate));
        row(messages.ordinary_pay+' · '+v.ordinary+' '+messages.hours_unit,money(r.ordinaryPay));
        if(v.overtime){row(messages.ot_first+' · '+r.firstHours+' × '+money(r.firstRate),money(r.firstPay));if(r.afterHours)row(messages.ot_after+' · '+r.afterHours+' × '+money(r.afterRate),money(r.afterPay));}
        if(r.addition)row(messages.addition,money(r.addition));
      }
      form.addEventListener('submit',e=>{e.preventDefault();active=true;calculate(true);});
      form.addEventListener('input',()=>calculate(active));form.addEventListener('change',()=>calculate(active));
      root.querySelector('[data-wage-example]').addEventListener('click',()=>{form.reset();Object.entries({award:'restaurant',employment:'casual',level:'2',day:'sunday',ordinary:'8',overtime:'0',late:'0',early:'0'}).forEach(([k,v])=>form.elements[k].value=v);form.elements.scope.checked=true;active=true;form.dispatchEvent(new Event('input',{bubbles:true}));});
      form.addEventListener('reset',()=>{active=false;setTimeout(()=>calculate(active),0);});
      calculate(false);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
  document.addEventListener('shopify:section:load',mount);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ice-hospitality-conversion-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
  function mount() {
    document.querySelectorAll('[data-ice-tool-tracking]').forEach(marker => {
      if (marker.dataset.ready) return;
      marker.dataset.ready = 'true';
      const scope = marker.closest('.shopify-section') || document;
      const toolName = marker.dataset.toolHandle || 'hospitality-tools';
      function track(name, detail = {}) {
        return window.icePhase50Analytics?.track(name, Object.assign({ tool_name: toolName }, detail)) || false;
      }
      function calculatorName(form) {
        if (form.closest('[data-ice50-finder]')) return form.closest('[data-ice50-finder]').dataset.calculator;
        if (form.matches('[data-finder-form], #ice-size-form')) return 'ice_machine_size_finder';
        if (form.matches('#it-wage-form') || form.closest('[data-ice-wage]')) return 'award_wage_calculator';
        if (form.dataset.itForm === 'energy') return 'equipment_energy_calculator';
        if (form.dataset.itForm === 'food') return 'food_cost_overheads_calculator';
        return toolName.replaceAll('-', '_');
      }
      function visible(node) {
        return node && !node.closest('[hidden], .hidden') && getComputedStyle(node).display !== 'none';
      }
      function resultFor(form) {
        if (form.id === 'ice-size-form') return scope.querySelector('#ice-size-output');
        if (form.id === 'it-wage-form') return scope.querySelector('#it-wage-result');
        return form.closest('[data-ice50-finder]')?.querySelector('[data-ice50-result]')
          || form.closest('[data-ice-finder]')?.querySelector('[data-finder-result]')
          || form.closest('[data-ice-wage]')?.querySelector('[data-wage-result]')
          || form.closest('.ice-tools')?.querySelector('[data-it-result]');
      }
      function start(form) {
        if (!form.dataset.iceTrackedStart && track('hospitality_tool_start', { calculator: calculatorName(form) })) form.dataset.iceTrackedStart = 'true';
      }
      function complete(form) {
        start(form);
        const error = [...form.querySelectorAll('[role="alert"], .it-error, [data-it-error]')].some(visible);
        if (!visible(resultFor(form)) || error || form.dataset.iceTrackedComplete) return;
        if (track('hospitality_tool_complete', { calculator: calculatorName(form) })) form.dataset.iceTrackedComplete = 'true';
      }
      scope.querySelectorAll('[data-it-form], [data-ice50-form], [data-finder-form], #ice-size-form, #it-wage-form, [data-ice-wage] form').forEach(form => {
        if (form.dataset.iceTrackingReady) return;
        form.dataset.iceTrackingReady = 'true';
        form.addEventListener('input', () => { delete form.dataset.iceTrackedComplete; start(form); });
        form.addEventListener('change', () => { delete form.dataset.iceTrackedComplete; start(form); });
        form.addEventListener('reset', () => { delete form.dataset.iceTrackedComplete; });
        form.addEventListener('submit', () => window.setTimeout(() => complete(form), 80));
      });
      scope.addEventListener('ice:capacity-complete', event => {
        const form = event.target.querySelector('[data-ice50-form]');
        if (form) complete(form);
      });
      scope.addEventListener('click', event => {
        const target = event.target.closest('a, button');
        if (!target || !target.closest('.ice-tools, .ice-size')) return;
        const form = target.closest('form') || target.closest('[data-ice50-finder], [data-ice-finder]')?.querySelector('form');
        const calculator = form ? calculatorName(form) : toolName.replaceAll('-', '_');
        if (target.matches('[data-wage-example], [data-finder-example], [data-it-example], [data-ice50-example]')) {
          track('hospitality_tool_example', { calculator });
          return;
        }
        if (target.matches('[data-ice50-copy], [data-copy-brief]')) {
          track('hospitality_tool_copy', { calculator });
          return;
        }
        if (target.matches('[data-ice50-print], [data-print-brief], [data-it-print]')) {
          track('hospitality_tool_print', { calculator });
          return;
        }
        if (!target.matches('a')) return;
        const raw = target.getAttribute('href') || '';
        if (/^(tel:|mailto:)/.test(raw)) {
          track('hospitality_tool_advice', { calculator, destination: raw.startsWith('tel:') ? 'phone' : 'email' });
          return;
        }
        const url = new URL(target.href, location.origin);
        if (url.origin !== location.origin) return;
        const destination = url.pathname + url.hash;
        const detail = { calculator, destination };
        if (url.pathname.startsWith('/products/')) track('hospitality_tool_product_click', detail);
        else if (url.pathname.startsWith('/collections/')) track('hospitality_tool_equipment_click', detail);
        else if (/^\/pages\/(contact-us|request-for-quote|commercial-kitchen-design|service-request-form)\/?$/.test(url.pathname)) track('hospitality_tool_advice', detail);
        else if (url.pathname.startsWith('/blogs/')) track('hospitality_tool_guide_click', detail);
        else if (/tools|calculator|finder/.test(destination)) track('hospitality_tool_select', detail);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ice-insights-style-lock"] && !Shopify.designMode) return;
  try {
    (function () {
  function prepareContents() {
    document.querySelectorAll('#col-main.post-single .post-content').forEach(function (content) {
      content.querySelectorAll('.ice-insights-toc, aside').forEach(function (toc) {
        if (!toc.querySelector('ol a[href^="#"]')) return;
        toc.classList.add('ice-insights-toc');
        if (!toc.querySelector('h2, h3')) {
          var heading = document.createElement('h2');
          heading.textContent = content.dataset.tocHeading;
          toc.prepend(heading);
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareContents, { once: true });
  } else {
    prepareContents();
  }
  document.addEventListener('shopify:section:load', prepareContents);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ice-machine-size-finder"] && !Shopify.designMode) return;
  try {
    (() => {
  const ceilFive=value=>Math.ceil(value/5)*5;
  const number=(form,name)=>Number(form.elements[name].value);
  const formatFor=target=>target<=60?'Self-contained or undercounter machine':target<=120?'High-output self-contained or compact modular machine':'Modular head with a separate storage bin';
  function mount(){
    document.querySelectorAll('[data-ice-finder]').forEach(root=>{
      if(root.dataset.ready)return;root.dataset.ready='true';
      const form=root.querySelector('[data-finder-form]'),error=root.querySelector('[data-finder-error]'),empty=root.querySelector('[data-finder-empty]'),result=root.querySelector('[data-finder-result]'),copyStatus=root.querySelector('[data-copy-status]'),shortlist=root.querySelector('[data-finder-shortlist]'),productGrid=root.querySelector('[data-product-grid]'),shortlistIntro=root.querySelector('[data-shortlist-intro]');
      const cataloguePromise=fetch(root.dataset.productsUrl,{credentials:'same-origin'}).then(response=>response.ok?response.json():[]).catch(()=>[]);
      let brief='';
      function detailRow(label,value){
        const row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;row.append(dt,dd);return row;
      }
      function productCard(product){
        const card=document.createElement('article');card.className='ice48-product-card';
        const imageWrap=document.createElement('div');imageWrap.className='ice48-product-card__image';
        const image=document.createElement('img');image.src=product.image;image.alt=product.imageAlt||product.title;image.loading='lazy';image.width=420;image.height=315;imageWrap.append(image);
        const body=document.createElement('div');body.className='ice48-product-card__body';
        const vendor=document.createElement('p');vendor.className='ice48-product-card__vendor';vendor.textContent=product.vendor;
        const title=document.createElement('h4');title.textContent=product.title;
        const details=document.createElement('dl');details.append(detailRow('Production',product.productionKg+' kg / 24 hours'),detailRow('Ice style',product.style),detailRow('Configuration',product.configuration==='modular'?'Modular':'Self-contained'));
        const note=document.createElement('p');note.className='ice48-product-card__note';note.textContent=product.storageKg?'Listed integrated storage: '+product.storageKg+' kg. Confirm site requirements with ICE Group.':product.configuration==='modular'?'Storage and installation requirements must be confirmed with ICE Group.':'Confirm storage, drainage and installation requirements with ICE Group.';
        const link=document.createElement('a');link.className='it-action it-primary';link.href='/products/'+product.handle;link.textContent='View equipment →';
        body.append(vendor,title,details,note,link);card.append(imageWrap,body);return card;
      }
      async function renderShortlist(target,storage,style,format){
        const catalogue=await cataloguePromise;productGrid.replaceChildren();shortlist.hidden=false;
        const formatLower=format.toLowerCase();
        const wantedConfiguration=formatLower.includes('compact modular')?'either':formatLower.includes('modular')?'modular':'self-contained';
        const stylePool=style==='Not sure—please advise'?catalogue:catalogue.filter(product=>product.style===style);
        const safePool=stylePool.filter(product=>product.productionKg>=target);
        shortlistIntro.textContent='Equipment-only matches at or above '+target+' kg per 24 hours. Installation components and accessories are confirmed separately with ICE Group.';
        if(!safePool.length){
          const message=document.createElement('div');message.className='ice48-no-match';message.textContent='No direct online equipment match meets every selected requirement. Contact ICE Group so the team can confirm a suitable commercial machine and installation plan.';productGrid.append(message);return;
        }
        const ranked=[...safePool].sort((a,b)=>{
          const aScore=(a.productionKg-target)/Math.max(target,1)+(wantedConfiguration==='either'||a.configuration===wantedConfiguration?0:.35)+((a.storageKg&&a.storageKg<storage)?.2:0);
          const bScore=(b.productionKg-target)/Math.max(target,1)+(wantedConfiguration==='either'||b.configuration===wantedConfiguration?0:.35)+((b.storageKg&&b.storageKg<storage)?.2:0);
          return aScore-bScore;
        });
        const selected=[],vendors=new Set();
        ranked.forEach(product=>{if(selected.length<3&&!vendors.has(product.vendor)){selected.push(product);vendors.add(product.vendor);}});
        ranked.forEach(product=>{if(selected.length<3&&!selected.includes(product))selected.push(product);});
        selected.forEach(product=>productGrid.append(productCard(product)));
      }
      async function calculate(showErrors=true){
        const fields=['daily_servings','grams','daily_extra','peak_servings','peak_extra','buffer'];
        const values=Object.fromEntries(fields.map(name=>[name,number(form,name)]));
        const invalid=!form.elements.venue.value||fields.some(name=>!Number.isFinite(values[name])||values[name]<Number(form.elements[name].min)||values[name]>Number(form.elements[name].max));
        const daily=values.daily_servings*values.grams/1000+values.daily_extra,peak=values.peak_servings*values.grams/1000+values.peak_extra;
        if(invalid||daily<=0||peak<=0){result.hidden=true;empty.hidden=false;if(showErrors){error.textContent='Enter a venue and positive daily and peak ice demand within the stated limits.';error.hidden=false;}return;}
        error.hidden=true;empty.hidden=true;result.hidden=false;
        const production=ceilFive(daily*(1+values.buffer/100)),storage=ceilFive(peak*(1+values.buffer/100)),format=form.elements.format.value==='auto'?formatFor(production):form.elements.format.value,style=form.elements.ice_style.value,venue=form.elements.venue.value;
        root.querySelector('[data-production]').textContent=production+' kg per 24 hours';root.querySelector('[data-demand]').textContent=daily.toFixed(1)+' kg per busiest day';root.querySelector('[data-storage]').textContent=storage+' kg';root.querySelector('[data-format]').textContent=format;root.querySelector('[data-style]').textContent=style;root.querySelector('[data-summary]').textContent=venue+' estimate with a '+values.buffer+'% operating buffer.';
        brief=['ICE Group Ice Machine Size Finder','Venue: '+venue,'Calculated daily demand: '+daily.toFixed(1)+' kg','Recommended production: '+production+' kg per 24 hours','Suggested storage: '+storage+' kg','Ice style: '+style,'Equipment format: '+format,'Operating buffer: '+values.buffer+'%','','Confirm water, filtration, drainage, power, ventilation, clearances, access and storage capacity.','Indicative planning guide only; final selection must be checked against site conditions and manufacturer-rated output.'].join('\n');
        await renderShortlist(production,storage,style,format);
      }
      form.addEventListener('submit',event=>{event.preventDefault();calculate(true);result.scrollIntoView({behavior:'smooth',block:'nearest'});});
      form.addEventListener('reset',()=>{setTimeout(()=>{error.hidden=true;result.hidden=true;empty.hidden=false;shortlist.hidden=true;productGrid.replaceChildren();copyStatus.textContent='';brief='';},0);});
      root.querySelector('[data-finder-example]').addEventListener('click',()=>{Object.entries({venue:'Bar or pub',daily_servings:'650',grams:'250',daily_extra:'20',peak_servings:'280',peak_extra:'10',buffer:'25',ice_style:'Cube ice',format:'auto'}).forEach(([name,value])=>form.elements[name].value=value);calculate(false);result.scrollIntoView({behavior:'smooth',block:'nearest'});});
      root.querySelector('[data-copy-brief]').addEventListener('click',async()=>{if(!brief)return;try{await navigator.clipboard.writeText(brief);copyStatus.textContent='Sizing brief copied.';}catch(e){const area=document.createElement('textarea');area.value=brief;document.body.append(area);area.select();document.execCommand('copy');area.remove();copyStatus.textContent='Sizing brief copied.';}});
      root.querySelector('[data-print-brief]').addEventListener('click',()=>window.print());
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
  document.addEventListener('shopify:section:load',mount);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ice-product-features-phase31"] && !Shopify.designMode) return;
  try {
    (function () {
  function standardiseProductDetails() {
    var labels = document.getElementById('IceProductDetailLabels');
    var detail = document.getElementById('tab_detail');
    if (!labels) return;
    if (detail && detail.getAttribute('data-ice-features-ready') !== 'true') {
      detail.setAttribute('data-ice-features-ready', 'true');
      Array.from(detail.querySelectorAll('p,div')).reverse().forEach(function (element) {
        if (element.textContent.replace(/\u00a0/g, ' ').trim()) return;
        if (element.querySelector('img,svg,iframe,video,audio,canvas,object,embed,table,ul,ol,input,button,hr,script,style')) return;
        if (Array.from(element.attributes).some(function (attribute) {
          return /^(?:id|class|role|aria-|data-)/.test(attribute.name) ||
            (attribute.name === 'style' && /(?:background|border|display|height|width)/i.test(attribute.value));
        })) return;
        element.remove();
      });
      detail.querySelectorAll('h2,h3,h4,h5,p,div,strong,b').forEach(function (element) {
        if (!detail.contains(element)) return;
        if (element.querySelector('p,div,h2,h3,h4,h5,ul,ol,table,a,img,input,button')) return;
        var text = element.textContent.replace(/\s+/g, ' ').trim();
        var kind = /^(?:(?:product|key|main) )?features?:?$/i.test(text) ? 'features' :
          /^(?:technical )?specifications?:?$/i.test(text) ? 'specifications' : '';
        if (!kind) return;
        var heading = document.createElement('h2');
        Array.from(element.attributes).forEach(function (attribute) {
          if (attribute.name !== 'style') heading.setAttribute(attribute.name, attribute.value);
        });
        heading.textContent = labels.dataset[kind];
        heading.classList.add(kind === 'features' ? 'ice-product-features-heading' : 'ice-product-specifications-heading');
        element.replaceWith(heading);
      });
      detail.querySelectorAll('table').forEach(function (table) {
        var rows = Array.from(table.rows);
        if (rows.length && rows.every(function (row) {
          return row.cells.length === 2 && row.cells[0].matches('th[scope="row"]') && row.cells[1].matches('td');
        })) table.classList.add('ice-compact-specifications');
        if (table.closest('.ice-product-table-scroll')) return;
        var region = document.createElement('div');
        region.className = 'ice-product-table-scroll';
        region.setAttribute('role', 'region');
        region.setAttribute('aria-label', labels.dataset.table);
        region.tabIndex = 0;
        table.before(region);
        region.appendChild(table);
      });
    }
    [['tab_pdf', 'a[href]'], ['tab_video', 'iframe,video,a[href]']].forEach(function (resource) {
      var panel = document.getElementById(resource[0]);
      if (!panel || panel.querySelector(resource[1]) || panel.textContent.trim()) return;
      var tab = document.querySelector('.product-simple-tab a[href="#' + resource[0] + '"]');
      if (tab && !tab.closest('li').classList.contains('active')) {
        tab.closest('li').classList.add('ice-empty-resource');
        panel.classList.add('ice-empty-resource');
      }
    });
    document.querySelectorAll('#tab_pdf a[target="_blank"]').forEach(function (link) {
      link.relList.add('noopener');
      var icon = link.querySelector('img');
      if (icon && !icon.hasAttribute('alt')) icon.alt = '';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', standardiseProductDetails, { once: true });
  } else {
    standardiseProductDetails();
  }
}());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ice-tools-expansion"] && !Shopify.designMode) return;
  try {
    (() => {
  class IceCapacityFinder extends HTMLElement {
    static parseNumber(value) {
      const text = String(value).trim();
      if (!/^(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$/.test(text)) return NaN;
      return Number(text.replaceAll(',', ''));
    }

    static coffee(values) {
      const multiplier = 1 + values.growth / 100;
      const forecastPeak = values.peak * multiplier;
      const forecastDaily = values.daily * multiplier;
      const groups = Math.max(1, Math.ceil((forecastPeak - 1e-9) / values.throughput));
      return { groups, forecastPeak, forecastDaily, dailyKg: forecastDaily * values.dose / 1000, peakKg: forecastPeak * values.dose / 1000 };
    }

    static dish(values) {
      const peak = Math.max(values.peak, values.covers / values.hours);
      const mixed = values.ware === 'mixed';
      const plateRacks = mixed ? peak * values.plates / values.plate_capacity : 0;
      const glassRacks = peak * values.glasses / values.glass_capacity;
      const cutleryRacks = mixed ? peak * values.cutlery / 100 : 0;
      const extraRacks = mixed ? values.extra : 0;
      const buffer = 1 + values.buffer / 100;
      const required = Math.ceil((plateRacks + glassRacks + cutleryRacks + extraRacks) * buffer - 1e-9);
      const practical = Math.floor(3600 / (values.cycle + values.handling) + 1e-9);
      const dailyBase = values.covers * ((mixed ? values.plates / values.plate_capacity + values.cutlery / 100 : 0) + values.glasses / values.glass_capacity) + extraRacks * values.hours;
      const dailyRacks = Math.ceil(dailyBase * buffer - 1e-9);
      const machineClass = mixed ? (required <= 30 ? 'under' : required <= 60 ? 'pass' : 'high') : (required <= 30 ? 'glass' : 'glass_high');
      return { peak, required, practical, dailyRacks, plateRacks, glassRacks, cutleryRacks, extraRacks, machineClass, averageUsed: peak > values.peak, gap: Math.max(0, required - practical) };
    }

    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.kind = this.dataset.kind;
      this.messages = JSON.parse(this.querySelector('[data-ice50-messages]').textContent);
      this.form = this.querySelector('form');
      this.result = this.querySelector('[data-ice50-result]');
      this.empty = this.querySelector('[data-ice50-empty]');
      this.error = this.querySelector('[data-ice50-error]');
      this.briefArea = this.querySelector('[data-ice50-brief]');
      this.copyStatus = this.querySelector('[data-ice50-copy-status]');
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { maximumFractionDigits: 2 });
      this.form.addEventListener('submit', event => { event.preventDefault(); this.calculate(true); });
      this.form.addEventListener('input', () => { this.invalidate(); });
      this.form.addEventListener('change', () => { this.syncWare(); this.invalidate(); });
      this.form.addEventListener('reset', () => { this.invalidate(); window.setTimeout(() => this.syncWare(), 0); });
      this.querySelector('[data-ice50-example]').addEventListener('click', () => this.example());
      this.querySelector('[data-ice50-copy]').addEventListener('click', () => this.copy());
      this.querySelector('[data-ice50-print]').addEventListener('click', () => {
        if (!this.brief) return;
        this.setAttribute('data-printing', '');
        window.print();
      });
      window.addEventListener('afterprint', () => this.removeAttribute('data-printing'));
      this.syncWare();
    }

    syncWare() {
      if (this.kind !== 'dish') return;
      const mixed = this.form.elements.dish_ware.value === 'mixed';
      this.form.querySelectorAll('[data-mixed-field]').forEach(field => {
        field.hidden = !mixed;
        field.querySelector('input').disabled = !mixed;
      });
    }

    invalidate() {
      this.brief = '';
      this.result.hidden = true;
      this.empty.hidden = false;
      this.error.hidden = true;
      this.copyStatus.textContent = '';
      this.briefArea.hidden = true;
      this.form.querySelectorAll('[aria-invalid]').forEach(input => input.removeAttribute('aria-invalid'));
    }

    number(value) { return this.format.format(value); }
    message(key, values = {}) {
      let message = (this.messages[key] || '').replaceAll('&amp;', '&');
      Object.entries(values).forEach(([name, value]) => { message = message.replaceAll('[' + name + ']', String(value)); });
      return message;
    }
    output(key, value) { this.querySelector('[data-output="' + key + '"]').textContent = value; }
    selectLabel(name) {
      const input = this.form.elements[this.kind + '_' + name];
      return input?.selectedOptions?.[0]?.textContent.trim() || '';
    }

    read() {
      const values = {};
      let failure = null;
      Array.from(this.form.elements).forEach(input => {
        if (!input.name) return;
        const key = input.name.slice(this.kind.length + 1);
        if (input.disabled) { values[key] = 0; return; }
        if (!input.hasAttribute('data-number')) { values[key] = input.value; return; }
        if (input.hasAttribute('data-optional') && !input.value.trim()) { values[key] = null; return; }
        const number = IceCapacityFinder.parseNumber(input.value);
        const minimum = Number(input.dataset.min), maximum = Number(input.dataset.max);
        const label = input.closest('label').querySelector('span').textContent.trim();
        if (!Number.isFinite(number) || number < minimum || number > maximum) {
          if (!failure) failure = { input, text: this.message('invalid', { label }) + ' ' + this.message('range', { min: this.number(minimum), max: this.number(maximum) }) };
          input.setAttribute('aria-invalid', 'true');
        } else input.removeAttribute('aria-invalid');
        values[key] = number;
      });
      if (!failure && values.peak > (this.kind === 'coffee' ? values.daily : values.covers)) {
        failure = { input: this.form.elements[this.kind + '_peak'], text: this.message('peak_error') };
      }
      if (!failure && this.kind === 'dish' && values.glasses === 0 && (values.ware === 'glasses' || values.plates + values.cutlery + values.extra === 0)) {
        failure = { input: this.form.elements.dish_glasses, text: this.message('no_ware') };
      }
      return { values, failure };
    }

    calculate(showErrors) {
      this.invalidate();
      const { values, failure } = this.read();
      if (failure) {
        if (showErrors) {
          this.error.textContent = this.message('error_prefix') + ' ' + failure.text;
          this.error.hidden = false;
          failure.input.setAttribute('aria-invalid', 'true');
          const details = failure.input.closest('details');
          if (details) details.open = true;
          failure.input.focus();
        }
        return false;
      }
      const result = this.kind === 'coffee' ? IceCapacityFinder.coffee(values) : IceCapacityFinder.dish(values);
      const lines = [this.message('brief_heading'), this.message('brief_date') + ': ' + new Date().toLocaleDateString('en-AU', { timeZone: 'Australia/Sydney' })];
      const line = (key, value) => lines.push(this.message(key) + ': ' + value);
      const units = (number, key) => this.number(number) + ' ' + this.message(key);
      if (this.kind === 'coffee') {
        const recommendation = this.message(result.groups > 3 ? 'group_multi' : ['group_one', 'group_two', 'group_three'][result.groups - 1]);
        this.output('recommendation', recommendation);
        this.output('forecastPeak', units(result.forecastPeak, 'per_hour'));
        this.output('forecastDaily', units(result.forecastDaily, 'per_day'));
        this.output('dailyKg', units(result.dailyKg, 'kg_day'));
        this.output('peakKg', units(result.peakKg, 'kg_hour'));
        this.output('coffeeGuidance', [this.message(values.milk >= 70 ? 'milk_guidance' : 'steam_guidance'), this.message(values.takeaway >= 50 ? 'takeaway_guidance' : 'dinein_guidance'), result.groups > 3 ? this.message('multi_guidance') : ''].filter(Boolean).join(' '));
        lines.push(recommendation);
        line('daily', this.number(values.daily)); line('peak', this.number(values.peak));
        line('forecast_peak', units(result.forecastPeak, 'per_hour')); line('forecast_daily', units(result.forecastDaily, 'per_day'));
        line('grinder_daily', units(result.dailyKg, 'kg_day')); line('grinder_peak', units(result.peakKg, 'kg_hour'));
        lines.push('', this.message('brief_assumptions'));
        line('throughput', this.number(values.throughput)); line('dose', this.number(values.dose));
        line('growth', this.number(values.growth)); line('milk', this.number(values.milk)); line('takeaway', this.number(values.takeaway));
      } else {
        const recommendation = this.message('class_' + result.machineClass);
        this.output('required', units(result.required, 'per_hour'));
        this.output('recommendation', recommendation);
        this.output('practical', units(result.practical, 'per_hour'));
        this.output('dailyRacks', this.number(result.dailyRacks));
        ['plateRacks', 'glassRacks', 'cutleryRacks', 'extraRacks'].forEach(key => this.output(key, units(result[key], 'per_hour')));
        this.output('dishGuidance', (result.gap ? this.message('gap', { gap: this.number(result.gap) }) : this.message('meets')) + (result.averageUsed ? ' ' + this.message('average_note') : ''));
        const mismatch = values.preference !== 'auto' && values.preference !== result.machineClass;
        this.output('preferenceGuidance', mismatch ? this.message('preference_note') : '');
        this.querySelector('[data-output="preferenceGuidance"]').hidden = !mismatch;
        lines.push(recommendation);
        line('required', units(result.required, 'per_hour')); line('practical', units(result.practical, 'per_hour')); line('daily_racks', this.number(result.dailyRacks));
        lines.push(this.selectLabel('venue')); line('ware', this.selectLabel('ware'));
        line('covers', this.number(values.covers)); line('peak', this.number(values.peak)); line('hours', this.number(values.hours));
        lines.push('', this.message('brief_assumptions'));
        ['plates','glasses','plate_capacity','glass_capacity','cutlery','extra','buffer','cycle','handling'].forEach(key => line(key, this.number(values[key])));
        line('preference', this.selectLabel('preference'));
        lines.push(this.querySelector('[data-output="dishGuidance"]').textContent);
      }
      lines.push('', this.message('brief_site'));
      line('width', values.width === null ? this.message('not_recorded') : units(values.width, 'mm'));
      line('power_label', this.selectLabel('power'));
      lines.push('', this.message('model_check'), this.message('brief_note'));
      this.brief = lines.join('\n');
      this.briefArea.value = this.brief;
      this.querySelector('[data-ice50-print-text]').textContent = this.brief;
      this.empty.hidden = true;
      this.result.hidden = false;
      this.result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      this.dispatchEvent(new CustomEvent('ice:capacity-complete', { bubbles: true, detail: { calculator: this.dataset.calculator } }));
      return true;
    }

    example() {
      this.form.reset();
      const example = this.kind === 'coffee' ? { daily: 650, peak: 150, milk: 85, takeaway: 75, growth: 20, throughput: 60, dose: 18 } : { venue: 'restaurant', ware: 'mixed', covers: 450, peak: 150, hours: 8, plates: 3, glasses: 2, plate_capacity: 18, glass_capacity: 25, cutlery: 3, extra: 4, buffer: 20, cycle: 120, handling: 30, preference: 'auto' };
      Object.entries(example).forEach(([name, value]) => { this.form.elements[this.kind + '_' + name].value = value; });
      this.syncWare();
      this.calculate(true);
    }

    async copy() {
      if (!this.brief) return;
      try {
        await navigator.clipboard.writeText(this.brief);
        this.copyStatus.textContent = this.message('copy_success');
      } catch (error) {
        this.briefArea.hidden = false;
        this.briefArea.focus();
        this.briefArea.select();
        this.copyStatus.textContent = this.message('copy_fallback');
      }
    }
  }
  if (!customElements.get('ice-capacity-finder')) customElements.define('ice-capacity-finder', IceCapacityFinder);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ice-tools-modern"] && !Shopify.designMode) return;
  try {
    (() => {
  function mount(){
    document.querySelectorAll('.ice-tools form').forEach(form=>{
      if(form.dataset.ice45Sliders)return;form.dataset.ice45Sliders='true';
      const hint=document.createElement('p');hint.className='ice45-range-note';hint.textContent=document.querySelector('[data-ice45-hint]')?.textContent||'';form.querySelector('.it-fields')?.before(hint);
      const settings={old:[0,50,.5],new:[0,50,.5],rate:[0,1,.01],days:[1,366,1],target:[1,100,1],revenue:[0,200000,1000],food:[0,100000,500],labour:[0,100000,500],rent:[0,30000,250],utilities:[0,20000,100],other:[0,30000,250],price:[0,30000,100],install:[0,10000,100],ordinary:[0,12,.25]};
      Object.entries(settings).forEach(([name,limits])=>{
        const input=form.elements[name];if(!input||!input.matches('input'))return;
        const label=input.closest('label');if(!label)return;
        const slider=document.createElement('input');slider.type='range';slider.className='ice45-range';slider.min=limits[0];slider.max=limits[1];slider.step=limits[2];slider.setAttribute('aria-label',label.querySelector('.it-label').textContent.trim());
        label.append(slider);
        function sync(){const value=Number(input.value.replaceAll(',',''));slider.max=Math.max(limits[1],Number.isFinite(value)?value:limits[1]);if(input.value!==''&&Number.isFinite(value))slider.value=value;else slider.value=limits[0];}
        slider.addEventListener('input',()=>{input.value=slider.value;input.dispatchEvent(new Event('input',{bubbles:true}));});
        form.addEventListener('input',sync);form.addEventListener('change',sync);form.addEventListener('reset',()=>setTimeout(sync,0));form.addEventListener('click',event=>{if(event.target.closest('[data-it-example]'))sync();});sync();
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
  document.addEventListener('shopify:section:load',mount);
})();
  } catch(e) { console.error(e); }
})();

})();
